import { create } from 'zustand';

import apiToken, { handleApiError } from '../services/axiosInstance';
import { UserState } from '../types/StoreTypes';

const CACHE_DURATION = 5 * 60 * 1000;

export const useUserStore = create<UserState>()((set, get) => ({
  userData: null,
  isLoading: false,
  error: null,
  lastFetched: null,

  fetchUserData: async () => {
    const { lastFetched, userData } = get();
    const now = Date.now();

    if (userData && lastFetched && now - lastFetched < CACHE_DURATION) {
      return;
    }

    set({ isLoading: true, error: null });

    try {
      const response = await apiToken.get('/api/v1/user');
      set({
        userData: response.data.data,
        isLoading: false,
        lastFetched: now,
        error: null,
      });
    } catch (error) {
      const errorMessage = handleApiError(error);
      console.error('Failed to fetch user info:', errorMessage);
      set({
        error: errorMessage,
        isLoading: false,
      });
    }
  },

  clearUserData: () => {
    set({
      userData: null,
      isLoading: false,
      error: null,
      lastFetched: null,
    });
  },
}));
